module.exports = __webpack_public_path__ + "img/estrella1.5940328b.png";